export { analyseAutomation } from './analyseAutomation'
